import { getBusinessOperation } from "../../../../actions/Utilities/BusinessOperation";
import { useQuery, useQueryClient } from "react-query";


export default function useGetBusinessOperation() {
  const {data, isFetching} = useQuery("GetBusinessOperation", getBusinessOperation, {
    refetchOnWindowFocus: false,
  });
  if(data){
    data.sort((a, b) => {
        let fa = a.businessOperationName.toLowerCase(), fb = b.businessOperationName.toLowerCase();
        return (fa < fb)?-1:(fa > fb?1:0);
    });
  }
  return {data, isFetching};
}
